import { ReactNode } from "react";

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  bottomContent?: ReactNode;
}

const PageTitle = ({ title, subtitle, bottomContent }: Props) => {
  return (
    <div className="px-8 pt-4.5">
      <div className="flex flex-col gap-2">
        <span className="text-[27px] leading-[1.14] font-bold tracking-[-0.76px] text-[#0B1420]">
          {title}
        </span>
        {subtitle && <p className="text-sm text-[#5B6472]">{subtitle}</p>}
      </div>
      {bottomContent && <div className="mt-5.5">{bottomContent}</div>}
    </div>
  );
};

export default PageTitle;
